import {
  createRoute,
  createSubRoute,
  createRouteHasChildrens,
  createSubRouteHasChildrens,
} from "./helper";
export default <Array<Router>>[
  createRoute(
    "fdashboard",
    "dashboard",
    "Reports.DashboardBacklog",
    () => import("../views/operation/reports/dashboard-backlog.vue"),
    "Reports.DashboardBacklog",
    "ivu-icon ivu-icon-md-pie"
  ),
  createRouteHasChildrens(
    "config",
    "Configs",
    "ivu-icon ivu-icon-ios-aperture",
    [
      createSubRoute(
        "template",
        "Configs.Templates",
        () => import("../views/setting/configuration/config.vue"),
        "Configs.Templates",
        "ivu-icon ivu-icon-md-archive"
      ),
      createSubRouteHasChildrens("grpuser", "GrpUser", "", [
        createSubRoute(
          "user",
          "Configs.Users.View",
          () => import("../views/setting/user/user.vue"),
          "Configs.Users",
          "ivu-icon ivu-icon-md-person"
        ),
        createSubRoute(
          "role",
          "Configs.Roles.View",
          () => import("../views/setting/role/role.vue"),
          "Configs.Roles",
          "ivu-icon ivu-icon-ios-construct"
        ),
      ]),
      createSubRouteHasChildrens("grpcustomer", "GrpCustomer", "", [
        createSubRoute(
          "customertype",
          "Configs.CustomerTypes.View",
          () => import("../views/meta/customer-type/customer-type.vue"),
          "Configs.CustomerTypes",
          "ivu-icon ivu-icon-ios-contacts"
        ),
        createSubRoute(
          "customer",
          "Configs.Customers.View",
          () => import("../views/meta/customer/customer.vue"),
          "Configs.Customers",
          "ivu-icon ivu-icon-md-bicycle"
        ),
        createSubRoute(
          "customer/:code",
          "Configs.Customers.View",
          () => import("../views/meta/customer/view-customer.vue"),
          "Configs.Customers.View",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "create/customer",
          "Configs.Customers.Create",
          () => import("../views/meta/customer/create-customer.vue"),
          "Configs.Customers.Create",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "update/customer/:code",
          "Configs.Customers.Update",
          () => import("../views/meta/customer/update-customer.vue"),
          "Configs.Customers.Update",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "customertype/:code",
          "Configs.CustomerTypes.View",
          () => import("../views/meta/customer-type/view-customer-type.vue"),
          "Configs.CustomerTypes.View",
          "",
          false
        ),
        createSubRoute(
          "create/customertype",
          "Configs.CustomerTypes.Create",
          () => import("../views/meta/customer-type/create-customer-type.vue"),
          "Configs.CustomerTypes.Create",
          "",
          false
        ),
        createSubRoute(
          "update/customertype/:code",
          "Configs.CustomerTypes.Update",
          () => import("../views/meta/customer-type/update-customer-type.vue"),
          "Configs.CustomerTypes.Update",
          "",
          false
        ),
      ]),
      createSubRouteHasChildrens("grpwarehouse", "GrpWarehouse", "", [
        createSubRoute(
          "tenant",
          "Configs.Warehouses.View",
          () => import("../views/setting/tenant/tenant.vue"),
          "Configs.Warehouses",
          "ivu-icon ivu-icon-md-home"
        ),
        createSubRoute(
          "room",
          "Configs.Rooms.View",
          () => import("../views/meta/room/room.vue"),
          "Configs.Rooms",
          "ivu-icon ivu-icon-ios-water"
        ),
        createSubRoute(
          "aisle",
          "Configs.Aisles.View",
          () => import("../views/meta/aisle/aisle.vue"),
          "Configs.Aisles",
          "ivu-icon ivu-icon-ios-grid"
        ),
        createSubRoute(
          "bin",
          "Configs.Bins.View",
          () => import("../views/operation/location/bin.vue"),
          "Configs.Bins",
          "ivu-icon ivu-icon-ios-pint"
        ),
        createSubRoute(
          "transport",
          "Configs.Transports.View",
          () => import("../views/operation/location/transport.vue"),
          "Configs.Transports",
          "ivu-icon ivu-icon-ios-basket"
        ),
        createSubRoute(
          "caseLabel",
          "Configs.CaseLabels.View",
          () => import("../views/meta/case-label/case-label.vue"),
          "Configs.CaseLabels",
          "ivu-icon ivu-icon-ios-archive"
        ),
        createSubRoute(
          "create/aisle",
          "Configs.Aisles.Create",
          () => import("../views/meta/aisle/create-aisle.vue"),
          "Configs.Aisles.Create",
          "",
          false
        ),
        createSubRoute(
          "update/aisle/:roomCode/:id",
          "Configs.Aisles.Update",
          () => import("../views/meta/aisle/update-aisle.vue"),
          "Configs.Aisles.Update",
          "",
          false
        ),
        createSubRoute(
          "view/aisle/:roomCode/:id",
          "Configs.Aisles.View",
          () => import("../views/meta/aisle/view-aisle.vue"),
          "Configs.Aisles.View",
          "",
          false
        ),
        createSubRoute(
          "create/room",
          "Configs.Rooms.Create",
          () => import("../views/meta/room/create-room.vue"),
          "Configs.Rooms.Create",
          "",
          false
        ),
        createSubRoute(
          "update/room/:id",
          "Configs.Rooms.Update",
          () => import("../views/meta/room/create-room.vue"),
          "Configs.Rooms.Update",
          "",
          false
        ),
        createSubRoute(
          "view/room/:id",
          "Configs.Rooms.View",
          () => import("../views/meta/room/view-room.vue"),
          "Configs.Rooms.View",
          "",
          false
        ),
        createSubRoute(
          "import-bin",
          "Configs.Bins.Import",
          () => import("../views/operation/location/import-bin.vue"),
          "Configs.Bins.Import",
          "",
          false
        ),
        createSubRoute(
          "import-transport",
          "Configs.Transports.Import",
          () => import("../views/operation/location/import-transport.vue"),
          "Configs.Transports.Import",
          "",
          false
        ),
      ]),
      createSubRouteHasChildrens("grpclient", "GrpClient", "", [
        createSubRoute(
          "client",
          "Configs.Clients.View",
          () => import("../views/setting/client/client.vue"),
          "Configs.Clients",
          "ivu-icon ivu-icon-md-people"
        ),
        createSubRoute(
          "product",
          "Configs.Products.View",
          () => import("../views/meta/product/product.vue"),
          "Configs.Products",
          "ivu-icon ivu-icon-ios-flower"
        ),
        createSubRoute(
          "productpricing",
          "Configs.ProductPricings.View",
          () => import("../views/meta/product-pricing/product-pricing.vue"),
          "Configs.ProductPricings",
          "ivu-icon ivu-icon-logo-usd"
        ),
        createSubRoute(
          "category",
          "Configs.Categories.View",
          () => import("../views/meta/category/category.vue"),
          "Configs.Categories",
          "ivu-icon ivu-icon-ios-folder-open"
        ),
        createSubRoute(
          "unit",
          "Configs.Units.View",
          () => import("../views/meta/unit/unit.vue"),
          "Configs.Units",
          "ivu-icon ivu-icon-ios-list"
        ),
        createSubRoute(
          "client/:type/:id",
          "Configs.Clients.View",
          () => import("../views/setting/client/create-client.vue"),
          "Client",
          "ivu-icon ivu-icon-md-people",
          false
        ),
        createSubRoute(
          "import-product",
          "Configs.Products.Import",
          () => import("../views/meta/product/import-product.vue"),
          "Configs.Products.Import",
          "ivu-icon ivu-icon-md-cloud-upload",
          false
        ),
        createSubRoute(
          "import-category",
          "Configs.Categories.Import",
          () => import("../views/meta/category/import-category.vue"),
          "Configs.Categories.Import",
          "ivu-icon ivu-icon-md-cloud-upload",
          false
        ),
        createSubRoute(
          "import-unit",
          "Configs.Units.Import",
          () => import("../views/meta/unit/import-unit.vue"),
          "Configs.Units.Import",
          "ivu-icon ivu-icon-md-cloud-upload",
          false
        ),
        createSubRoute(
          "view/productpricing/:id",
          "Configs.ProductPricings.View",
          () =>
            import("../views/meta/product-pricing/view-product-pricing.vue"),
          "Configs.ProductPricings.View",
          "",
          false
        ),
        createSubRoute(
          "create/productpricing",
          "Configs.ProductPricings.Create",
          () =>
            import("../views/meta/product-pricing/create-product-pricing.vue"),
          "Configs.ProductPricings.Create",
          "",
          false
        ),
        createSubRoute(
          "update/productpricing/:id",
          "Configs.ProductPricings.Update",
          () =>
            import("../views/meta/product-pricing/update-product-pricing.vue"),
          "Configs.ProductPricings.Update",
          "",
          false
        ),
        createSubRoute(
          "product/:id",
          "Configs.Products.View",
          () => import("../views/meta/product/view-product.vue"),
          "Configs.Products.View",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "create/product/",
          "Configs.Products.Create",
          () => import("../views/meta/product/create-product.vue"),
          "Configs.Products.Create",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "update/product/:id",
          "Configs.Products.Update",
          () => import("../views/meta/product/edit-product.vue"),
          "Configs.Products.Update",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
      ]),
      createSubRouteHasChildrens("grpCollectionCode", "GrpCollectionCode", "", [
        createSubRoute(
          "collectionCode",
          "Configs.CollectionCodes.View",
          () => import("../views/meta/collection-code/collectionCode.vue"),
          "Configs.CollectionCodes",
          "ivu-icon ivu-icon-md-person"
        ),
        createSubRoute(
          "sessionPrint",
          "Configs.SessionPrintCollectionCodes.View",
          () =>
            import("../views/meta/session-print-collection-code/sessionPrintCollectionCode.vue"),
          "Configs.SessionPrintCollectionCodes",
          "ivu-icon ivu-icon-md-archive"
        ),
        createSubRoute(
          "view/collectionCode/:code",
          "Configs.CollectionCodes.View",
          () => import("../views/meta/collection-code/view-collectionCode.vue"),
          "Configs.CollectionCodes.View",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
      ]),

      createSubRoute(
        "sessionPrint/:id",
        "Configs.SessionPrintCollectionCodes.View",
        () =>
          import("../views/meta/session-print-collection-code/view-sessionPrintCollectionCode.vue"),
        "Configs.SessionPrintCollectionCodes.View",
        "",
        false
      ),
      createSubRoute(
        "tpl",
        "Configs.Tpls.View",
        () => import("../views/meta/tpl/tpl.vue"),
        "Configs.Tpls",
        "ivu-icon ivu-icon-md-bus"
      ),
      createSubRoute(
        "tpl/:code",
        "Configs.Tpls.View",
        () => import("../views/meta/tpl/view-tpl.vue"),
        "Configs.Tpls.View",
        "",
        false
      ),
      createSubRoute(
        "create/tpl",
        "Configs.Tpls.Create",
        () => import("../views/meta/tpl/create-tpl.vue"),
        "Configs.Tpls.Create",
        "",
        false
      ),
      createSubRoute(
        "update/tpl/:code",
        "Configs.Tpls.Update",
        () => import("../views/meta/tpl/update-tpl.vue"),
        "Configs.Tpls.Update",
        "",
        false
      ),
      createSubRoute(
        "warrantyDurationConfig",
        "Configs.WarrantyDurationConfig.View",
        () => import("../views/setting/warrantyDurationConfig/list.vue"),
        "Thời gian BH sản phẩm",
        "ivu-icon ivu-icon-md-menu"
      ),
      createSubRoute(
        "TimeAllowsWarrantyActivateConfig",
        "Configs.TimeAllowsWarrantyActivateConfig.View",
        () => import("../views/setting/TimeAllowsWarrantyActivateConfig/list.vue"),
        "Thời gian cho phép kích hoạt bảo hành",
        "ivu-icon ivu-icon-md-menu"
      ),
    ],
    true
  ),
  createRouteHasChildrens(
    "operations",
    "Operations",
    "ivu-icon ivu-icon-md-desktop",
    [
      createSubRoute(
        "purchaseorder",
        "Operations.PurchaseOrders.View",
        () => import("../views/operation/purchase-order/purchase-order.vue"),
        "Operations.PurchaseOrders",
        "ivu-icon ivu-icon-md-clipboard"
      ),
      createSubRoute(
        "saleorder-request",
        "Operations.SalesOrderRequests.View",
        () =>
          import("../views/operation/sale-order-request/sale-order-request.vue"),
        "Operations.SalesOrderRequests",
        "ivu-icon ivu-icon-ios-albums"
      ),
      createSubRoute(
        "saleorder",
        "Operations.SalesOrders.View",
        () => import("../views/operation/sale-order/sale-order.vue"),
        "Operations.SalesOrders",
        "ivu-icon ivu-icon-ios-albums"
      ),
      createSubRouteHasChildrens(
        "inout-receipt",
        "Operations.ReceivingDelivering",
        "",
        [
          createSubRoute(
            "po-receipt",
            "Operations.ReceivingDelivering.PoReceipts.View",
            () => import("../views/operation/po-receipt/po-receipt.vue"),
            "Receiving",
            "ivu-icon ivu-icon-ios-options"
          ),
          createSubRoute(
            "delivery-note",
            "Operations.ReceivingDelivering.DeliveryNotes.View",
            () => import("../views/operation/delivery-note/delivery-note.vue"),
            "Delivering",
            "ivu-icon ivu-icon-ios-options"
          ),
          createSubRoute(
            "view/po-receipt/:id",
            "Operations.ReceivingDelivering.PoReceipts.View",
            () => import("../views/operation/po-receipt/view-po-receipt.vue"),
            "Operations.ReceivingDelivering.PoReceipts.View",
            "ivu-icon ivu-icon-md-clipboard",
            false
          ),
          createSubRoute(
            "view/delivery-note/:id",
            "Operations.ReceivingDelivering.DeliveryNotes.View",
            () =>
              import("../views/operation/delivery-note/view-delivery-note.vue"),
            "Operations.ReceivingDelivering.DeliveryNotes.View",
            "ivu-icon ivu-icon-md-clipboard",
            false
          ),
        ]
      ),
      createSubRoute(
        "transferorder",
        "Operations.TransferOrders.View",
        () => import("../views/operation/transfer-orders/transfer-order.vue"),
        "Operations.TransferOrders",
        "ivu-icon ivu-icon-ios-options"
      ),
      createSubRouteHasChildrens("grpReturnOrder", "GrpReturnOrder", "", [
        createSubRoute(
          "returnOrder",
          "Operations.ReturnOrders.View",
          () => import("../views/operation/returnOrders/returnOrder.vue"),
          "Operations.ReturnOrders.View",
          "ivu-icon ivu-icon-ios-options"
        ),
        createSubRoute(
          "returnOrder-receipt",
          "Operations.ReturnOrders.Receipts",
          () =>
            import("../views/operation/returnOrderReceipts/returnOrderReceipt.vue"),
          "Operations.ReturnOrders.Receipts",
          "ivu-icon ivu-icon-ios-options"
        ),
        createSubRoute(
          "view/returnOrder/:id",
          "Operations.ReturnOrders.View",
          () => import("../views/operation/returnOrders/view-returnOrder.vue"),
          "Operations.ReturnOrders.View",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "view/returnOrderReceipt/:id",
          "Operations.ReturnOrders.Receipts",
          () =>
            import("../views/operation/returnOrderReceipts/view-returnOrderReceipt.vue"),
          "Operations.ReturnOrders.Receipts",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
      ]),

      createSubRouteHasChildrens("grppicklist", "GrpPickList", "", [
        createSubRoute(
          "pick-list",
          "Operations.PickList.View",
          () => import("../views/operation/pick-list/pick-list.vue"),
          "Operations.PickList",
          "ivu-icon ivu-icon-md-albums"
        ),
        createSubRoute(
          "packing",
          "Operations.Packing",
          () => import("../views/operation/packing/packing.vue"),
          "Operations.Packing",
          "ivu-icon ivu-icon-md-cube"
        ),
        createSubRoute(
          "grouping-package",
          "Operations.GroupingPackage",
          () =>
            import("../views/operation/grouping-packages/grouping-package.vue"),
          "Operations.GroupingPackage",
          "ivu-icon ivu-icon-md-albums"
        ),
        createSubRoute(
          "handoversession",
          "Operations.HandoverSession.View",
          () =>
            import("../views/operation/handoversessions/handoversession.vue"),
          "Operations.HandoverSession",
          "ivu-icon ivu-icon-ios-jet"
        ),
        createSubRoute(
          "picklist/:code",
          "Operations.PickList.View",
          () => import("../views/operation/pick-list/view-pick-list.vue"),
          "Operations.PickList.View",
          "ivu-icon ivu-icon-md-albums",
          false
        ),
        createSubRoute(
          "view-handoversession/:id",
          "Operations.HandoverSession.View",
          () =>
            import("../views/operation/handoversessions/view-handover-session.vue"),
          "Operations.HandoverSession.View",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "create-handoversession",
          "Operations.HandoverSession.Create",
          () =>
            import("../views/operation/handoversessions/create-handover-session.vue"),
          "Operations.HandoverSession.Create",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "update-handoversession/:id",
          "Operations.HandoverSession.Update",
          () =>
            import("../views/operation/handoversessions/update-handover-session.vue"),
          "Operations.HandoverSession.Update",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "create-picklist",
          "Operations.PickList.Create",
          () => import("../views/operation/pick-wave/create-pick-wave.vue"),
          "Operations.PickList.Create",
          "",
          false
        ),
        createSubRoute(
          "grouping-package/create",
          "Operations.GroupingPackage",
          () =>
            import("../views/operation/grouping-packages/create-grouping-package.vue"),
          "Operations.GroupingPackage.Create",
          "",
          false
        ),
        createSubRoute(
          "grouping-package/view/:code",
          "Operations.GroupingPackage",
          () =>
            import("../views/operation/grouping-packages/view-grouping-package.vue"),
          "Operations.GroupingPackage.View",
          "",
          false
        ),
        createSubRoute(
          "grouping-package/update/:code",
          "Operations.GroupingPackage",
          () =>
            import("../views/operation/grouping-packages/update-grouping-package.vue"),
          "Operations.GroupingPackage.Update",
          "",
          false
        ),
      ]),
      createSubRoute(
        "lostfound",
        "Operations.LostFoundIssue.View",
        () => import("../views/operation/lost-founds/lost-found.vue"),
        "Operations.LostFoundIssue",
        "ivu-icon ivu-icon-ios-chatboxes"
      ),
      createSubRoute(
        "invoiceseq",
        "Operations.InvoiceSeqs.View",
        () => import("../views/operation/invoice-seq/invoice-seq.vue"),
        "Operations.InvoiceSeqs",
        "ivu-icon ivu-icon-md-filing"
      ),
      createSubRouteHasChildrens("grpsupport", "GrpSupport", "", [
        createSubRoute(
          "view-location",
          "Operations.ViewLocation",
          () => import("../views/operation/location/location.vue"),
          "Operations.ViewLocation",
          "ivu-icon ivu-icon-md-reorder"
        ),
        createSubRoute(
          "search-product-location",
          "Operations.SearchLocationContainProduct",
          () =>
            import("../views/operation/location/search-product-location.vue"),
          "Operations.SearchLocationContainProduct",
          "ivu-icon ivu-icon-md-reorder"
        ),
        createSubRoute(
          "transAuditProductItemReport",
          "Reports.ProductHistories",
          () =>
            import("../views/operation/inventory/trans-audit-product-item-report.vue"),
          "Reports.ProductHistories",
          "ivu-icon ivu-icon-md-paper"
        ),
        createSubRoute(
          "barcode",
          "Operations.GenBarcode",
          () => import("../views/meta/bar-code/gen-bar-code.vue"),
          "Operations.GenBarcode",
          "ivu-icon ivu-icon-md-barcode"
        ),
        createSubRoute(
          "location-locking",
          "Operations.LocationLocking.View",
          () => import("../views/operation/location/locking/locking.vue"),
          "Operations.LocationLocking",
          "ivu-icon ivu-icon-md-reorder"
        ),
        createSubRoute(
          "view-locking/:id",
          "Operations.LocationLocking.View",
          () => import("../views/operation/location/locking/view-locking.vue"),
          "Operations.LocationLocking.View",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
        createSubRoute(
          "create-locking",
          "Operations.LocationLocking.Create",
          () =>
            import("../views/operation/location/locking/create-locking.vue"),
          "Operations.LocationLocking.Create",
          "ivu-icon ivu-icon-md-clipboard",
          false
        ),
      ]),
      createSubRoute(
        "errorLog",
        "Operations.ErrorLog",
        () => import("../views/operation/error-log/errorLog.vue"),
        "Operations.ErrorLog",
        "ivu-icon ivu-icon-md-person"
      ),

      createSubRoute(
        "view/purchaseorder/:code",
        "Operations.PurchaseOrders.View",
        () =>
          import("../views/operation/purchase-order/view-purchase-order.vue"),
        "Operations.PurchaseOrders.View",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "create/purchaseorder",
        "Operations.PurchaseOrders.Create",
        () =>
          import("../views/operation/purchase-order/create-purchase-order.vue"),
        "Operations.PurchaseOrders.Create",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "update/purchaseorder/:clientCode/:code",
        "Operations.PurchaseOrders.Update",
        () =>
          import("../views/operation/purchase-order/create-purchase-order.vue"),
        "Operations.PurchaseOrders.Update",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "create/saleorder",
        "Operations.SalesOrders.Create",
        () => import("../views/operation/sale-order/create-sales-order.vue"),
        "Operations.SalesOrders.Create",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "view/saleorder/:code",
        "Operations.SalesOrders.View",
        () => import("../views/operation/sale-order/view-sale-order.vue"),
        "Operations.SalesOrders.View",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "view/purchaseorder-checkin/:code",
        "Operations.PurchaseOrders.ViewCheckIn",
        () =>
          import("../views/operation/purchase-order/view-purchase-order-checkin.vue"),
        "Operations.PurchaseOrders.ViewCheckIn",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "create/purchaseorder-checkin/:code",
        "Operations.PurchaseOrders.CreateCheckIn",
        () =>
          import("../views/operation/purchase-order/create-purchase-order-checkin.vue"),
        "CreateCheckInPurchaseOrder",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "create/transferorder",
        "Operations.TransferOrders.Create",
        () =>
          import("../views/operation/transfer-orders/create-transfer-order.vue"),
        "Operations.TransferOrders.Create",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "view/transferorder/:id",
        "Operations.TransferOrders.View",
        () =>
          import("../views/operation/transfer-orders/view-transfer-order.vue"),
        "Operations.TransferOrders.View",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "import-transferOrder",
        "Operations.TransferOrders.Create",
        () =>
          import("../views/operation/transfer-orders/import-transfer-order.vue"),
        "Operations.TrasnferOrders.Import1",
        "ivu-icon ivu-icon-md-cloud-upload",
        false
      ),
      createSubRoute(
        "view-lostfound/:id",
        "Operations.LostFoundIssue.View",
        () => import("../views/operation/lost-founds/view-lost-found.vue"),
        "Operations.LostFoundIssue.View",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "create-invoice-seq",
        "Operations.InvoiceSeqs.Create",
        () => import("../views/operation/invoice-seq/create-invoice-seq.vue"),
        "Operations.HandoverSession.Create",
        "",
        false
      ),
      createSubRoute(
        "import-purchaseorder",
        "Operations.PurchaseOrders.Import",
        () =>
          import("../views/operation/purchase-order/import-purchase-order.vue"),
        "Operations.PurchaseOrders.Import",
        "ivu-icon ivu-icon-md-cloud-upload",
        false
      ),
      createSubRoute(
        "import-saleOrder",
        "Operations.SalesOrders.Import",
        () => import("../views/operation/sale-order/import-sale-order.vue"),
        "Operations.SalesOrders.Import",
        "ivu-icon ivu-icon-md-cloud-upload",
        false
      ),
      createSubRoute(
        "view/saleorder-request/:id",
        "Operations.SalesOrderRequests.View",
        () =>
          import("../views/operation/sale-order-request/view-sale-order-request.vue"),
        "Operations.SalesOrderRequests.View",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "create/saleorder-request",
        "Operations.SalesOrderRequests.Create",
        () =>
          import("../views/operation/sale-order-request/create-sales-order-request.vue"),
        "Operations.SalesOrderRequests.Create",
        "ivu-icon ivu-icon-md-clipboard",
        false
      ),
      createSubRoute(
        "import-salesOrder-request",
        "Operations.SalesOrderRequests.Import",
        () =>
          import("../views/operation/sale-order-request/import-sales-order-request.vue"),
        "Operations.SalesOrderRequests.Import",
        "ivu-icon ivu-icon-md-cloud-upload",
        false
      ),
    ],
    true
  ),
  createRouteHasChildrens("eWarranty", "EWarranty", "", [
    createSubRoute(
      "activate",
      "EWarranty.ActivateWarranty",
      () =>
        import("../views/operation/warranty-activation/activate-warranty.vue"),
      "EWarranty.ActivateWarranty",
      "ivu-icon ivu-icon-md-person"
    ),
    createSubRoute(
      "warranty-activation",
      "EWarranty.View",
      () =>
        import("../views/operation/warranty-activation/warranty-activation.vue"),
      "EWarranty.View",
      "ivu-icon ivu-icon-md-person"
    ),
    createSubRoute(
      "collectionCode-products",
      "EWarranty.CollectionCodeProduct",
      () =>
        import("../views/operation/warranty-activation/collectionCode-product.vue"),
      "EWarranty.CollectionCodeProduct",
      "ivu-icon ivu-icon-md-person"
    ),
    createSubRoute(
      "change-stamp",
      "EWarranty.ChangeStamp",
      () => import("../views/operation/warranty-activation/change-stamp.vue"),
      "EWarranty.ChangeStamp",
      "ivu-icon ivu-icon-md-person"
    ),
  ]),
  createRouteHasChildrens(
    "report",
    "Reports",
    "ivu-icon ivu-icon-ios-stats",
    [
      createSubRouteHasChildrens("grpinventory", "GrpInventoryReport", "", [
        createSubRoute(
          "inventoryreport",
          "Reports.Inventories",
          () => import("../views/operation/inventory/inventory-report.vue"),
          "Reports.Inventories",
          "ivu-icon ivu-icon-md-paper"
        ),
        createSubRoute(
          "general-inventory",
          "Reports.GeneralInventoryReport",
          () =>
            import("../views/operation/inventory/general-inventory-report.vue"),
          "Reports.GeneralInventoryReport",
          "ivu-icon ivu-icon-md-paper"
        ),
        createSubRoute(
          "inventoryAgingReport",
          "Reports.AgingInventories",
          () => import("../views/operation/reports/inventory-aging-report.vue"),
          "Reports.AgingInventories",
          "ivu-icon ivu-icon-md-paper"
        ),
      ]),
      createSubRouteHasChildrens(
        "grpinventorystats",
        "GrpInventoryStatReport",
        "",
        [
          createSubRoute(
            "customer-statement",
            "Reports.CustomerStatement",
            () =>
              import("../views/operation/inventory/customer-statement-report.vue"),
            "Reports.CustomerStatement",
            "ivu-icon ivu-icon-md-paper"
          ),
          createSubRoute(
            "productstatementreport",
            "Reports.ProductStatement",
            () =>
              import("../views/operation/inventory/product-statement-report.vue"),
            "Reports.ProductStatement",
            "ivu-icon ivu-icon-md-paper"
          ),
        ]
      ),
      createSubRouteHasChildrens("grpinout", "GrpInOutReport", "", [
        createSubRoute(
          "purchasingStatisticsReport",
          "Reports.PurchasingStatistics",
          () =>
            import("../views/operation/purchase-order/purchasing-statistics.vue"),
          "Reports.PurchasingStatistics",
          "ivu-icon ivu-icon-md-paper"
        ),
        createSubRoute(
          "salesStatisticsReport",
          "Reports.SalesStatistics",
          () => import("../views/operation/sale-order/sales-statistics.vue"),
          "Reports.SalesStatistics",
          "ivu-icon ivu-icon-md-paper"
        ),
      ]),
      createSubRouteHasChildrens("grpuserreports", "GrpUserReport", "", [
        createSubRoute(
          "employeeproductivityreport",
          "Reports.EmployeesProductivity",
          () =>
            import("../views/operation/reports/employee-productivity-report.vue"),
          "Reports.EmployeesProductivity",
          "ivu-icon ivu-icon-md-paper"
        ),
        createSubRoute(
          "employee-job-diary",
          "Reports.EmployeeJobDiary",
          () =>
            import("../views/operation/reports/employee-job/employee-job-diary.vue"),
          "Reports.EmployeeJobDiary",
          "ivu-icon ivu-icon-md-paper"
        ),
      ]),
      createSubRouteHasChildrens(
        "grpwarrantyreports",
        "GrpWarrantyReport",
        "",
        [
          createSubRoute(
            "warranty-activations",
            "Reports.WarrantyActivations",
            () => import("../views/operation/reports/warranty-activation.vue"),
            "Reports.WarrantyActivations",
            "ivu-icon ivu-icon-md-medal"
          ),
        ]
      ),
      createSubRoute(
        "serialNoReport",
        "Reports.SerialNos",
        () => import("../views/operation/inventory/serial-no-report.vue"),
        "Reports.SerialNos",
        "ivu-icon ivu-icon-md-paper"
      ),
      createSubRoute(
        "collectionCodeTracking",
        "Reports.CollectionCodeTracking",
        () => import("../views/operation/reports/collectioncode-tracking.vue"),
        "Reports.CollectionCodeTracking",
        "ivu-icon ivu-icon-md-paper"
      ),
      createSubRouteHasChildrens(
        "grpshortedreports",
        "GrpProductShortedReport",
        "",
        [
          createSubRoute(
            "preorder-shorted-sku",
            "Reports.PreOrderShortedSku",
            () =>
              import("../views/operation/reports/preorder/preorder-shorted-sku.vue"),
            "Reports.PreOrderShortedSku",
            "ivu-icon ivu-icon-md-reorder"
          ),
          createSubRoute(
            "preorder-shorted-sku-so-request",
            "Reports.PreOrderShortedSkuBySoRequestCodes",
            () =>
              import("../views/operation/reports/preorder/preorder-shorted-sku-sorequest-code.vue"),
            "Reports.PreOrderShortedSkuBySoRequestCodes",
            "ivu-icon ivu-icon-md-reorder"
          ),
        ]
      ),
      createSubRoute(
        "pa-so-shorted-sku",
        "Reports.PASalesOrderShortedSku",
        () => import("../views/operation/reports/pa-so/pa-so-shorted-sku.vue"),
        "Reports.PASalesOrderShortedSku",
        "ivu-icon ivu-icon-md-reorder"
      ),
      createSubRoute(
        "change-stamp",
        "Reports.ChangeStamp",
        () =>
          import("../views/meta/collection-code/report-CollectionCodeChange.vue"),
        "Reports.ChangeStamp",
        "ivu-icon ivu-icon-ios-stats"
      ),
    ],
    true
  ),
  createRoute(
    "/",
    "main-change-password",
    "",
    () => import("../views/setting/user/main-change-password.vue"),
    "ChangeUserPassword",
    "",
    null,
    false
  ),
];
